import TicketStore from './TicketStore';
import PackageStore from './PackageStore';
import ReservationStore from './ReservationStore';

const ticketStore = new TicketStore();
const packageStore = new PackageStore();
const reservationStore = new ReservationStore();

export default {
  ticketStore,
  packageStore,
  reservationStore
}


// WEBPACK FOOTER //
// ./src/stores/index.js